var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { useDrop } from "react-dnd";
import { ItemTypes } from "./ItemTypes";
export var Dropper = function (_a) {
    var id = _a.id, children = _a.children;
    var _b = __read(useDrop(function () { return ({
        accept: ItemTypes.BOX,
        drop: function () { return ({ id: id }); },
        collect: function (monitor) { return ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }); },
    }); }), 2), _c = _b[0], canDrop = _c.canDrop, isOver = _c.isOver, drop = _b[1];
    var isActive = canDrop && isOver;
    return (_jsx(Box, { ref: drop, sx: {
            display: "flex",
            flexDirection: "column",
            gap: 1,
            minHeight: "150px",
            width: "100%",
            backgroundColor: isActive ? "action.hover" : "background.default",
            border: "1px dashed grey",
            borderRadius: 1,
            padding: 1,
            boxSizing: "border-box",
        }, children: children }));
};
